import Loadable from 'react-loadable';

const ChestInventory = Loadable({
  loader: () => import(/* webpackChunkName: "ChestInventory" */ './ChestInventory'),
  modules: ['./ChestInventory'],
  loading: () => null
});

export default ChestInventory;
